import { useSelector, useDispatch } from "react-redux";
import DatepickerComponent from "../components/datepickerComponent";
import { setEndDate } from "../reducers/endDateSlice";
import { setStartDate } from "../reducers/startDateSlice";
import { setDateRange } from "../reducers/dateRangeSlice";
import moment from "moment";

const DatepickersContainer = () => {
  const startDate = useSelector((state) => state.startDate);
  const endDate = useSelector((state) => state.endDate);

  const dispatch = useDispatch();

  const boundSetStartDate = (date) => dispatch(setStartDate(date));
  const boundSetEndDate = (date) => dispatch(setEndDate(date));
  const boundSetDateRange = (dateRange) => dispatch(setDateRange(dateRange));

  return (
    <DatepickerComponent
      startDate={moment(startDate)}
      endDate={moment(endDate)}
      setStartDate={boundSetStartDate}
      setEndDate={boundSetEndDate}
      setDateRange={boundSetDateRange}
    />
  );
};

export default DatepickersContainer;
